import { Forms } from "@/types/form";
import { sdk } from "@/config/medusa";
import { useUser } from "@/context/user";
import { useNavigate } from "react-router-dom";
import { getRoutes, handleErrorToast } from "@/utils/helpers";
import { Actor } from "@/types/utils";

const useLogin = () => {
  const setGlobalLoading = useUser((state) => state.setGlobalLoading);
  const login = useUser((state) => state.login);
  const navigate = useNavigate();
  const routes = getRoutes();

  const onLogin = async (data: Forms["Login"]) => {
    try {
      setGlobalLoading(true);
      const { email, password } = data;

      await sdk.auth.login("vendor-admin", "emailpass", {
        email,
        password,
      });

      const admin =
        await sdk.client.fetch<Forms["VendorUser"]>("/vendor/users/me");
      const { actor_type } = await sdk.client.fetch<Actor>("/actor/me");

      login(admin, actor_type);
      navigate(routes.dashboard);
    } catch (e) {
      handleErrorToast(e);
    } finally {
      setGlobalLoading(false);
    }
  };

  return { onLogin };
};

export { useLogin };
